"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _static = require("@otpusk/json-api/dist/static");
var _localization = _interopRequireDefault(require("../../../../../../localization"));
var _enableCurrencies = require("../../../../../../constants/enableCurrencies");
var _pluralTranslations = require("../../../../../../localization/pluralTranslations");
var _Select = _interopRequireDefault(require("../../../../../ui/Select"));
var _Tooltip = _interopRequireWildcard(require("../../../../../ui/Tooltip"));
var _bed = _interopRequireDefault(require("./img/bed.svg"));
var _person = _interopRequireDefault(require("./img/person.svg"));
var _food = _interopRequireDefault(require("./img/food.svg"));
var _date = _interopRequireDefault(require("./img/date.svg"));
var _insurance = _interopRequireDefault(require("./img/insurance.svg"));
var _transfer = _interopRequireDefault(require("./img/transfer.svg"));
var _localBar = _interopRequireDefault(require("./img/local-bar.svg"));
var _luggage = _interopRequireDefault(require("./img/luggage.svg"));
var _no_luggage = _interopRequireDefault(require("./img/no_luggage.svg"));
var _paid = _interopRequireDefault(require("./img/paid.svg"));
var _never_land = _interopRequireDefault(require("./img/never_land.svg"));
var _train_transfer_to_airport = _interopRequireDefault(require("./img/train_transfer_to_airport.svg"));
var _no_transfer = _interopRequireDefault(require("./img/no_transfer.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getLabel = function getLabel(currency) {
  return currency.code === _static.CURRENCIES_MAP.kzt.code ? currency.symbol : currency.label;
};
var CURRENCIE_OPTIONS = R.map(function (currency) {
  return {
    content: R.join(' ', [R.toUpper(currency.code), getLabel(currency)]),
    value: currency.code
  };
}, (0, _enableCurrencies.getEnableCurrenciesList)());
var INCLUDES_OPTIONS_MAP = _defineProperty(_defineProperty(_defineProperty(_defineProperty({
  insurance: {
    icon: _insurance.default,
    get text() {
      return _localization.default.t('TOUR_OPTIONS:INSURANCE');
    }
  },
  transfer: {
    icon: _transfer.default,
    get text() {
      return _localization.default.t('TOUR_OPTIONS:TRANSFER');
    }
  },
  gala: {
    icon: _localBar.default,
    get text() {
      return _localization.default.t('TOUR_OPTIONS:GALA_DINNER');
    }
  },
  luggage: {
    icon: _luggage.default,
    get text() {
      return _localization.default.t('TOUR_OPTIONS:LUGGAGE');
    }
  },
  noluggage: {
    icon: _no_luggage.default,
    get text() {
      return _localization.default.t('TOUR_OPTIONS:NO_LUGGAGE');
    },
    tooltip: {
      get content() {
        return _localization.default.t('OFFER_DETAILS:NO_LUGGAGE_OPTION_HINT');
      }
    }
  },
  touristax: {
    icon: _paid.default,
    get text() {
      return _localization.default.t('TOUR_OPTIONS:TOURSISTAX');
    }
  }
}, _static.TOUR_OPTIONS.NEVER_LAND, {
  icon: _never_land.default,
  get text() {
    return _localization.default.t('TOUR_OPTIONS:NEVER_LAND');
  }
}), _static.TOUR_OPTIONS.LUGGAGE_BY_REQUEST, {
  icon: _luggage.default,
  get text() {
    return _localization.default.t('TOUR_OPTIONS:LUGGAGE_BY_REQUEST');
  }
}), _static.TOUR_OPTIONS.TRAIN_TRANSFER_TO_AIRPORT, {
  icon: _train_transfer_to_airport.default,
  get text() {
    return _localization.default.t('TOUR_OPTIONS:TRAIN_TRANSFER_TO_AIRPORT');
  }
}), _static.TOUR_OPTIONS.NO_TRANSFER, {
  icon: _no_transfer.default,
  get text() {
    return _localization.default.t('TOUR_OPTIONS:NO_TRANSFER');
  }
});
var computeAdditionalNights = function computeAdditionalNights(nights, nightsInHotel) {
  return R.call(R.ifElse(function (diff) {
    return diff > 0;
  }, function (diff) {
    return " + ".concat(diff);
  }, R.F), nights - nightsInHotel);
};
var getLuggageInfo = function getLuggageInfo(flights) {
  return R.call(R.pipe(R.concat, R.groupBy(R.path(['luggage', 'registered'])), R.toPairs, R.find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      groupedFlights = _ref2[1];
    return R.equals(groupedFlights.length, flights.inbound.length + flights.outbound.length);
  }), R.when(Boolean, function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      registred = _ref4[0];
    return registred !== 'undefined' ? registred : null;
  })), flights.inbound, flights.outbound);
};
var Info = function Info(_ref5) {
  var adults = _ref5.adults,
    adultsFromOperator = _ref5.adultsFromOperator,
    child = _ref5.child,
    currency = _ref5.currency,
    foodFullName = _ref5.foodFullName,
    flights = _ref5.flights,
    includes = _ref5.includes,
    informationOfCrossTour = _ref5.informationOfCrossTour,
    nights = _ref5.nights,
    nightsInHotel = _ref5.nightsInHotel,
    room = _ref5.room,
    onCurrencyChange = _ref5.onCurrencyChange;
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation.t;
  var adultsTranslation = (0, _pluralTranslations.usePluralAdultsTranslation)();
  var kidsTranslation = (0, _pluralTranslations.usePluralKidsTranslation)();
  var nightsTranslation = (0, _pluralTranslations.usePluralNightsTranslation)();
  var yearsTranslation = (0, _pluralTranslations.usePluralYearsTranslation)();
  var additionalNights = computeAdditionalNights(nights, nightsInHotel);
  var finallyNights = additionalNights ? nightsInHotel : nights;
  var luggageInfo = (0, _react.useMemo)(function () {
    return getLuggageInfo(flights);
  }, [flights]);
  var isDifferentAdultsCount = adultsFromOperator !== adults;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.offerInfo
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.offerHeader
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.offerTitle
  }, t('OFFER_DETAILS_TITLE')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.currencyControlWrapper
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    disabled: !onCurrencyChange,
    items: CURRENCIE_OPTIONS,
    value: currency,
    onChange: onCurrencyChange
  }))), informationOfCrossTour && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.combinedTours
  }, informationOfCrossTour), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.offerInfoList
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.offerInfoItem
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_styles.default.icon, _styles.default.bed),
    dangerouslySetInnerHTML: {
      __html: _bed.default
    }
  }), room, isDifferentAdultsCount && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ' ', "(".concat(adultsFromOperator, " ").concat(adultsTranslation(adultsFromOperator), ")"))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.offerInfoItem
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_styles.default.icon, _styles.default.person),
    dangerouslySetInnerHTML: {
      __html: _person.default
    }
  }), adults, ' ', adultsTranslation(adults), Boolean(child.length) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ' + ', child.length, ' ', kidsTranslation(child.length), ' ', "(".concat(child.join(', '), " ").concat(yearsTranslation(R.last(child)), ")"))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.offerInfoItem
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_styles.default.icon, _styles.default.food),
    dangerouslySetInnerHTML: {
      __html: _food.default
    }
  }), foodFullName), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.offerInfoItem
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_styles.default.icon, _styles.default.date),
    dangerouslySetInnerHTML: {
      __html: _date.default
    }
  }), /*#__PURE__*/_react.default.createElement("div", null, finallyNights, ' ', nightsTranslation(finallyNights), additionalNights && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: t('ADDITIONAL_NIGHTS_TOOLTIP_TEXT'),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("span", null, additionalNights)))), R.map(function (tourOption) {
    var option = INCLUDES_OPTIONS_MAP[tourOption];
    if (!option) {
      return false;
    }
    var icon = option.icon,
      text = option.text,
      tooltip = option.tooltip;
    var shouldRenderLuggageInfo = Boolean(tourOption === 'luggage' && luggageInfo);
    var optionJSX = /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_styles.default.offerInfoItem, _styles.default[tourOption]),
      key: tourOption
    }, icon && /*#__PURE__*/_react.default.createElement("span", {
      className: _styles.default.icon,
      dangerouslySetInnerHTML: {
        __html: icon
      }
    }), shouldRenderLuggageInfo ? "".concat(text, " ").concat(luggageInfo) : text);
    return tooltip ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      content: tooltip.content,
      placement: _Tooltip.PLACEMENTS.TOP,
      trigger: [_Tooltip.TRIGGERS.HOVER]
    }, optionJSX) : optionJSX;
  }, includes)));
};
var flightType = _propTypes.default.shape({
  luggage: _propTypes.default.shape({
    registered: _propTypes.default.string
  })
});
Info.propTypes = {
  adults: _propTypes.default.number.isRequired,
  adultsFromOperator: _propTypes.default.number.isRequired,
  child: _propTypes.default.arrayOf(_propTypes.default.number).isRequired,
  currency: _propTypes.default.oneOf(R.map(R.prop('code'), (0, _enableCurrencies.getEnableCurrenciesList)())).isRequired,
  flights: _propTypes.default.shape({
    inbound: _propTypes.default.arrayOf(flightType),
    outbound: _propTypes.default.arrayOf(flightType)
  }),
  foodFullName: _propTypes.default.string.isRequired,
  includes: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  informationOfCrossTour: _propTypes.default.string,
  nights: _propTypes.default.number.isRequired,
  nightsInHotel: _propTypes.default.number.isRequired,
  room: _propTypes.default.string.isRequired,
  onCurrencyChange: _propTypes.default.func
};
var _default = exports.default = (0, _react.memo)(Info);